<mat-select [placeholder]="placeholder" [disabled]="disabled" [value]="_value" (selectionChange)="selectionChange($event)">
    <mat-select-trigger>
        <span *ngIf="label && _value !== null" class="filter-prefix">{{label}}:</span>
        <ng-template #defaultSelectTemplate let-value>
            {{value ? value: ''}}
        </ng-template>
        <ng-container [ngTemplateOutlet]="selectTemplateRef || defaultSelectTemplate" [ngTemplateOutletContext]="{ $implicit: _value }"></ng-container>
    </mat-select-trigger>
    <mat-option *ngIf="canSelectAll && (options && options.length > 1)" [value]="null">All</mat-option>
    <mat-option *ngFor="let option of options" [value]="option">
        <ng-template #defaultOptionTemplate let-option>
            {{option}}
        </ng-template>
        <ng-container [ngTemplateOutlet]="optionTemplateRef || defaultOptionTemplate" [ngTemplateOutletContext]="{ $implicit: option }">
        </ng-container>
    </mat-option>
</mat-select>
